<template>
    <v-navigation-drawer
        app
        clipped
        permanent
        expand-on-hover
        rail
        color="primary"
        @update:rail="onDrawerToggle"
    >
        <!-- <perfect-scrollbar style="height: 100%"> -->
        <v-list nav>
            <v-list-item
                link
                :href="route('home', stand.id)"
                @click.prevent="redirect(route('home', stand.id))"
                :class="[
                    route('home', stand.id) == currentUrl
                        ? 'primaryLight'
                        : 'white',
                ]"
                class="mt-4"
            >
                <template #prepend>
                    <v-icon
                        :class="[
                            route('home', stand.id) == currentUrl
                                ? 'primary--text'
                                : 'grey--text-darken-1',
                        ]"
                        >mdi-home-outline</v-icon
                    >
                </template>
                <v-list-item-title
                    :class="[
                        route('home', stand.id) == currentUrl
                            ? 'primary--text'
                            : 'textLight--text',
                        'fade-text',
                        { 'fade-out': !isDrawerOpen },
                    ]"
                    class="text-body-2 text-uppercase font-weight-bold"
                    >{{ $t("navigation.dashboard") }}</v-list-item-title
                >
            </v-list-item>

            <v-list-subheader
                v-if="isDrawerOpen"
                :class="[
                    'text-caption font-weight-bold my-4 text-uppercase text-white',
                    { 'fade-out': !isDrawerOpen },
                ]"
            >
                {{ $t("navigation.servicios") }}
            </v-list-subheader>

            <v-list-group
                v-for="item in menu"
                :key="item.nombre"
                :prepend-icon="item.icono"
                v-model="item.activo"
            >
                <template #activator="{ props }">
                    <v-list-item v-bind="props">
                        <v-list-item-title
                            :class="[
                                'text-body-2 fade-text',
                                {
                                    'fade-out': !isDrawerOpen,
                                    'v-hidden': !isDrawerOpen,
                                },
                            ]"
                            style="height: auto; white-space: normal"
                            v-if="isDrawerOpen"
                            >{{ item.nombre }}
                        </v-list-item-title>
                    </v-list-item>
                </template>

                <template
                    v-for="forma in item.formas"
                    :key="`${item.nombre}-${forma.id}`"
                >
                    <BotonDinamico
                        :forma="forma"
                        :stand="stand"
                        :user="user"
                        origen="1"
                    >
                        <template #default="{ attrs, accion }">
                            <v-list-item
                                v-bind="attrs"
                                @click.stop="accion"
                                :value="`${item.nombre}-${forma.id}`"
                            >
                                <template #prepend>
                                    <v-icon icon="mdi-menu-right"></v-icon>
                                </template>
                                <v-list-item-title
                                    :class="[
                                        'text-body-2 fade-text',
                                        { 'fade-out': !isDrawerOpen },
                                    ]"
                                    style="height: auto; white-space: normal"
                                    >{{ forma.nombre }}</v-list-item-title
                                >
                            </v-list-item>
                        </template>
                    </BotonDinamico>
                </template>
            </v-list-group>
        </v-list>
        <!-- </perfect-scrollbar> -->
    </v-navigation-drawer>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useMenuStore } from "../stores/menu.js";
import { usePage, router } from "@inertiajs/vue3";
import BotonDinamico from "../components/BotonDinamico.vue";

const menuStore = useMenuStore();
const page = usePage();

const itemId = ref(null);
const itemFormas = ref([]);
const currentUrl = ref(null);
const expand = ref(false);
const mini = ref(false);
const isActive = ref(false);
const isDrawerOpen = ref(false);
const drawer = ref(null);

onMounted(() => {
    currentUrl.value = window.location.href;
    // Initialize drawer state - check if it's in rail mode (closed)
    setTimeout(() => {
        if (drawer.value) {
            isDrawerOpen.value = !drawer.value.$el.classList.contains(
                "v-navigation-drawer--rail"
            );
        }
    }, 1000);
});

const asd = (e) => {
    console.log(e);
    if (e) {
        menu.value.forEach((item) => {
            if (item.activo) {
                itemId.value = item.id;
                item.activo = false;
                itemFormas.value = item.formas;
            }
            item.formas = [];
        });
    }
    if (!e) {
        menu.value.forEach((item) => {
            if (item.id === itemId.value) {
                item.formas = itemFormas.value;
                item.activo = true;
            }
        });
    }
};

const navigation = () => {
    expand.value = !expand.value;
    mini.value = expand.value;
    if (expand.value) asd(true);
};

const onDrawerToggle = (rail) => {
    if (rail) {
        isDrawerOpen.value = false;
    } else {
        setTimeout(() => {
            isDrawerOpen.value = true;
        }, 200);
    }
};

const redirect = (url) => {
    // Check if we're already on the target URL
    const isCurrentPage = window.location.href === url;

    if (isCurrentPage) {
        // Force a fresh visit without preserving state to reset everything
        router.visit(url, {
            preserveState: false,
            preserveScroll: false,
            replace: false,
        });
    } else {
        // Navigate normally with preserved state
        router.get(url, {}, { preserveState: true });
    }
};

const menu = computed(() => page.props.menu);
const stand = computed(() => page.props.stand);
const user = computed(() => page.props.user);
</script>

<style scoped>
.fade-text {
    transition: opacity 300ms ease-in-out;
    opacity: 1;
    position: relative;
}

.fade-text.fade-out {
    opacity: 0;
    position: absolute;
    left: -9999px;
    width: 0;
    height: 0;
    overflow: hidden;
}
</style>
